/* eslint-disable */
import _ from 'lodash'

export const state = () => ({
  socketPersistName: '',
  isSocketConnected: false,
  isDoctorAuthorized: false,
  isRecorded: true,
  isCalling: false,
  inConsultation: false,
  isPatientNeedSummary: true,
  hasQuiz: false,

  doctorSessionID: null,
  patientSessionID: null,
  patientID: null,
  labResultID: null,
  statusData: null,
  icd10: [],

  genericName: [],

  category: [],
  categoryIndex: [],
  categoryLength: [],

  tagCategoryLength: [],
  tagCategory: [],
  tagIndex: [],

  choosenIndex: null,
  catText: '',

  label: [],
  labelIndex: [],

  scheduleAppointmentList: [],

  scheduleTimer: {
    deadline: null,
    counterIntervalObject: null,
    epochTimer: null,
    timerSeconds: '',
    timerMinutes: '',
    timerHours: '',
    timerDays: '',
    timerWeeks: '',
    timerMonths: '',
    timerYears: ''
  },
  expiredConsultationTimer: {
    counterIntervalObject: null,
    epochTimer: null,
    timerSeconds: '',
    timerMinutes: ''
  },
  callingPatientTimer: {
    counterIntervalObject: null,
    epochTimer: null,
    timerSeconds: '',
    timerMinutes: ''
  },
  summaryTimer: {
    loadingSendSummary: false,
    deadline: null,
    isExtend: false,
    counterIntervalObject: null,
    epochTimer: null,
    timerSeconds: '',
    timerMinutes: '',
    timerHours: '',
    timerDays: '',
    timerWeeks: '',
    timerMonths: '',
    timerYears: ''
  },

  consultation: {
    consultationID: null,
    schedule: null,
    consultationType: null,
    consultationTypeFlag: null,
    userSymptoms: null,
    userSymptomsID: null,
    userSymptomsIcon: null,
    patientPersonalData: null,
    consultationTimerDeadline: null,
    consultationTimer: null,
    lastConsultationTimer: null,
    consultationTimerObject: null,
    runningTime: 0,
    runningTimeObject: null,
    pharmacy: null,
    videoEnabled: true,
    reconnectData: null,
    isTyping: false,
    consultationMode: 'Video', // Video or Phone
    patientInfo: null,
    status: 'Idle',
    chat: [],
    attachment: null
  },
  timeRemainingAttempt: 5,

  videoStream: null,
  photoStream: null,
  localSDP: null,
  remoteSDP: null,
  position: null,
  callStatus: null,
  missedCallTimeout: null,
  callEndedBy: null, // doctor, patient, connection
  missedCallTimeoutTime: 180000,
  expiredConsultationTime: 3 * 60 * 1000,
  consultationTime: 600000,
  consultationSummaryTimerTime: 600000,
  consultationSummaryExtendTimerTime: 120000,

  patientData: {
    patient: {}
  },

  statistics: {
    success: {
      data: null,
      loading: false
    },

    canceled: {
      data: null,
      loading: false
    },

    record: {
      data: null,
      loading: false
    }
  },

  preview_attachment: false,
  previewImage: {
    modal: false,
    url: ''
  },
  consultFrom: {},
  pharmacyDetail: {},
  logRecordedFile: []
})

export const mutations = {
  SET_SOCKET_PERSIST_NAME: (state, value) => {
    state.socketPersistName = value
  },

  CONNECT: (state) => {
    state.isSocketConnected = true
  },

  SET_VIDEO_STREAM: (state, value) => {
    state.videoStream = value
  },

  SET_PHOTO_STREAM: (state, value) => {
    state.photoStream = value
  },

  SET_CONSULT_FROM: (state, value) => {
    state.consultFrom = value
  },

  SET_SCHEDULE_APPOINTMENT_LIST: (state, value) => {
    state.scheduleAppointmentList = value
  },

  SET_RECORDED: (state, value) => {
    state.isRecorded = value
  },

  SET_POSITION: (state, value) => {
    state.position = value
  },

  SET_IN_CONSULTATION: (state, value) => {
    state.inConsultation = value
  },

  SET_DOCTOR_SESSION_ID: (state, value) => {
    state.doctorSessionID = value
  },

  SET_PATIENT_SESSION_ID: (state, value) => {
    state.patientSessionID = value
  },

  SET_PATIENT_ID: (state, value) => {
    state.patientID = value
  },

  SET_IS_PATIENT_NEED_SUMMARY: (state, value) => {
    state.isPatientNeedSummary = value
  },

  SET_CHOOSEN_INDEX: (state, value) => {
    state.choosenIndex = value
    state.genericName = []
  },

  SET_CONSULTATION: (state, data) => {
    const { key, value } = data
    if (key === 'chat') {
      if (typeof value.index !== 'undefined' && value.index > -1) { state.consultation[key][value.index] = value } else { state.consultation[key].push(value) }
    } else { state.consultation[key] = value }
  },

  SET_CHAT_CONSULTATION: (state, data) => {
    const { key, value } = data
    state.consultation[key] = value
  },

  ADD_CHAT_CONSULTATION: (state, data) => {
    const { key, value } = data
    state.consultation[key].push(value)
  },

  SET_SCHEDULE_TIMER: (state, data) => {
    const { key, value } = data
    state.scheduleTimer[key] = value
  },

  SET_EXPIRED_CONSULTATION_TIMER: (state, data) => {
    const { key, value } = data
    state.expiredConsultationTimer[key] = value
  },

  SET_CALLING_PATIENT_TIMER: (state, data) => {
    const { key, value } = data
    state.callingPatientTimer[key] = value
  },

  SET_SUMMARY_TIMER: (state, data) => {
    const { key, value } = data
    state.summaryTimer[key] = value
  },

  SET_DOCTOR_AUTHORIZED: (state, value) => {
    state.isDoctorAuthorized = value
  },

  SET_ICD_10: (state, value) => {
    state.icd10 = value
  },

  SET_GENERIC: (state, value) => {
    state.genericName = value
  },

  SET_CATEGORY: (state, value) => {
    if (state.categoryIndex.length === 0) {
      state.categoryIndex.push(value.index)
      state.category.push(value.response)
      state.categoryLength.push(value.length)
    } else {
      let same = 0
      state.categoryIndex.forEach((recent, i) => {
        if (recent === value.index) {
          state.category[i] = value.response
          state.categoryLength[i] = value.length
          same += 1
        }
      })
      if (same === 0) {
        state.categoryIndex.push(value.index)
        state.category.push(value.response)
        state.categoryLength.push(value.length)
      }
    }
  },
  SET_TAG_CATEGORY: (state, value) => {
    if (state.tagIndex.length === 0) {
      state.tagIndex.push(value.index)
      state.tagCategory.push(value.response)
      state.tagCategoryLength.push(value.length)
    } else {
      let same = 0
      state.tagIndex.forEach((recent, i) => {
        if (recent === value.index) {
          state.tagCategory[i] = value.response
          state.tagCategoryLength[i] = value.length
          same += 1
        }
      })
      if (same === 0) {
        state.tagIndex.push(value.index)
        state.tagCategory.push(value.response)
        state.tagCategoryLength.push(value.length)
      }
    }
  },

  SET_LABEL: (state, value) => {
    if (state.labelIndex.length === 0) {
      state.label.push(value.response)
      state.labelIndex.push(value.index)
    } else {
      let same = 0
      state.labelIndex.forEach((label, id) => {
        if (label === value.index) {
          state.label[id] = value.response
          same += 1
        }
      })
      if (same === 0) {
        state.label.push(value.response)
        state.labelIndex.push(value.index)
      }
    }
  },

  SET_TAG_CATEGORY_TEXT: (state, value) => {
    state.catText = value
  },

  SET_MISSED_CALL_TIMEOUT: (state, value) => {
    state.missedCallTimeout = value
  },

  SET_MISSED_CALL_TIMEOUT_TIME: (state, value) => {
    state.missedCallTimeoutTime = value
  },

  SET_CALLING: (state, value) => {
    state.isCalling = value
  },

  SET_CALL_STATUS: (state, value) => {
    state.callStatus = value
  },

  SET_LAB_RESULT_ID: (state, value) => {
    state.labResultID = value
  },

  SET_STATUS_DATA: (state, value) => {
    state.statusData = value
  },

  SET_LOCAL_SDP: (state, value) => {
    state.localSDP = value
  },

  CALL_END_BY: (state, value) => {
    state.callEndedBy = value
  },

  RESET: (state, customAction) => {
    state.isDoctorAuthorized = false
    state.isCalling = false
    state.isRecorded = true
    state.inConsultation = false
    state.hasQuiz = false

    state.labResultID = null
    state.statusData = null
    state.doctorSessionID = null
    state.patientID = null
    state.patientSessionID = null

    state.consultation.consultationType = null
    state.consultation.consultationTypeFlag = null
    state.consultation.consultationID = null
    state.consultation.consultationMode = 'Video'
    state.consultation.userSymptoms = null
    state.consultation.userSymptomsID = null
    state.consultation.userSymptomsIcon = null
    state.consultation.patientPersonalData = customAction === 'KEEP_PATIENT_PERSONAL_DATA' ? state.consultation.patientPersonalData : null
    state.consultation.consultationTimer = null
    state.consultation.lastConsultationTimer = null
    state.consultation.consultationTimerObject = null
    state.consultation.runningTime = 0
    state.consultation.runningTimeObject = null
    state.consultation.reconnectData = null
    state.consultation.pharmacy = null
    state.consultation.videoEnabled = true
    state.consultation.isTyping = true
    state.consultation.patientInfo = customAction === 'KEEP_PATIENT_INFO_DATA' ? state.consultation.patientInfo : null
    state.consultation.chat = []
    state.consultation.history = {
      data: []
    }

    state.position = null
    state.localSDP = null
    state.remoteSDP = null

    state.callStatus = null
    state.missedCallTimeout = null
    state.callEndedBy = null
  },

  STOP_MEDIA_STREAM: (state) => {
    if (state.videoStream) {
      state.videoStream.getTracks().forEach((track) => {
        track.stop()
      })
    }
  },

  SET_PATIENT_DATA: (state, value) => {
    state.patientData = value
  },

  SET_STATISTIC_DATA: (state, data) => {
    const { key, value } = data

    if (state.statistics[key]) { state.statistics[key].data = value }
  },

  SET_STATISTIC_LOADING: (state, data) => {
    const { key, value } = data

    if (state.statistics[key]) { state.statistics[key].loading = value }
  },

  SET_PREVIEW_ATTACHMENT: (state, value) => {
    state.preview_attachment = value
  },

  SET_DATA_ATTACHMENT: (state, value) => {
    state.consultation.attachment = value
  },

  SET_HISTORY_PATIENT: (state, value) => {
    state.consultation.history = value
  },

  SET_PREVIEW_IMAGE: (state, value) => {
    state.previewImage = value
  },

  SET_PHARMACY_DETAIL: (state, value) => {
    state.pharmacyDetail = value
  },

  SET_LOG_RECORDED_FILE: (state, value) => {
    state.logRecordedFile.push(value)
  },

  SET_TIME_REMAINING_ATTEMPT: (state, value) => {
    state.timeRemainingAttempt = value
  }
}

export const actions = {
  setQueue ({ commit, state, rootState }, token) {
    return new Promise((resolve, reject) => {
      if (state.consultation.reconnectData) {
        console.log('RECONNECTING...')
        commit('SET_DOCTOR_SESSION_ID', state.consultation.reconnectData.ID)
        resolve(true)
      } else {
        const formData = new FormData()

        formData.append('CalendarID', rootState.calendar.currentSchedule.PublicID)

        if (rootState.calendar.currentSchedule.Appointment) { formData.append('AppointmentPublicID', rootState.calendar.currentSchedule.Appointment.PublicID) }

        this.$api.post('doctor/enter/queue', formData, {})
          .then(function (response) {
            const res = response.data.Data
            commit('SET_DOCTOR_SESSION_ID', res.DoctorSessionID)
            resolve(res)
          })
          .catch(function (error) {
            reject(error)
          })
      }
    })
  },

  checkReconnect ({ commit }, data) {
    return new Promise((resolve, reject) => {
      this.$api.get('doctor/check/reconnecting', {})
        .then(function (response) {
          const res = response.data.Data

          if (res) {
            if (res.Practicing) {
              commit('SET_CONSULTATION', {
                key: 'reconnectData',
                value: res
              })
              commit('SET_CONSULTATION', {
                key: 'status',
                value: 'DoctorReconnect'
              })
            }
          }

          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  checkUnfinishedConsultation ({ commit }, ConsultationID) {
    return new Promise((resolve, reject) => {
      this.$api.post('doctor/practicing/unfinished/' + ConsultationID, {})
        .then(function (response) {
          const res = response

          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  checkStatusConsultation ({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      if (rootState.calendar.currentSchedule && rootState.calendar.currentSchedule.Appointment && rootState.calendar.currentSchedule.Appointment.Calendar) {
        this.$api.post('doctor/consultation/status', {
          PatientID: rootState.calendar.currentSchedule.Appointment.Calendar.PatientID,
          CalendarOnlineID: rootState.calendar.currentSchedule.Appointment.CalendarDoctorOnlineID,
          AppointmentID: rootState.calendar.currentSchedule.Appointment.ID
        })
          .then(function (response) {
            const res = response
            commit('SET_STATUS_DATA', res)
            resolve(res)
          })
          .catch(function (error) {
            reject(error)
          })
      }
    })
  },

  checkIncompleteConsultation ({ dispatch, state, rootState, commit }) {
    return new Promise((resolve, reject) => {
      this.$api.get(rootState.user.auth.role_endpoint + 'check/incomplete/consultation')
        .then(async (response) => {
          const res = response.data.Data.Data

          if (response.data.Data.Status) {
            if (res.Consultation.Status === null || res.Consultation.Status === 'Not Ready') {
              commit('SET_CONSULTATION', {
                key: 'consultationID',
                value: res.Consultation.ID
              })
              commit('SET_PATIENT_ID', res.Patient.ID)
              commit('SET_PATIENT_SESSION_ID', res.Consultation.PatientSessionID)
              commit('SET_CONSULTATION', {
                key: 'pharmacy',
                value: res.Pharmacy
              })

              commit('SET_CONSULTATION', {
                key: 'userSymptoms',
                value: res.Consultation.Symptoms
              })

              // API not return this data yet
              // commit('SET_CONSULTATION', {
              //   'key': 'userSymptomsID',
              //   'value': res.patientSymptom.id,
              // })
              // commit('SET_CONSULTATION', {
              //   'key': 'userSymptomsIcon',
              //   'value': res.patientSymptom.icon,
              // })

              dispatch('endTimer')

              await dispatch('getConsultationSchedule').then((response) => {
                dispatch('calculateSummaryTimer',
                  {
                    startConsultTime: parseInt(response.End)
                  }
                ).then((calculateResponse) => {
                  if (res.Consultation.StatusCode == 'PA') { commit('CALL_END_BY', 'connection') } else if (res.Consultation.StatusCode == 'PE') { commit('CALL_END_BY', 'patient') } else if (res.Consultation.StatusCode == 'TO') { commit('CALL_END_BY', 'timer') } else { commit('CALL_END_BY', 'doctor') }

                  commit('SET_CALL_STATUS', 'CALL_ENDED')
                  commit('SET_IN_CONSULTATION', false)
                  commit('SET_POSITION', 4)
                  dispatch('getPatientInfoByConsultationID').then(()=>{
                    // call modal modalIsPatientNeedSummary
                    if (res.Consultation.Status == null) {
                      if (res.Consultation.StatusCode && res.Consultation.StatusCode !== 'DE' && res.Consultation.StatusCode !== 'TO') {
                        if(state.consultFrom) {
                          if(state.consultFrom.IsAllowedConsultationICD10) {
                            $nuxt.$bvModal.show('modalIsPatientNeedSummary')
                          }
                        } else {
                          $nuxt.$bvModal.show('modalIsPatientNeedSummary')
                        }
                      }
                    }
                  })
                  $nuxt.$bvModal.hide('modalIceConnectionDie')
                  $nuxt.$bvModal.hide('modalPatientConnectionDie')
                })
              }).catch(() => {
                dispatch('calculateSummaryTimer',
                  {
                    startConsultTime: parseInt(res.consultation.TimeStart),
                    endConsultTime: parseInt(res.consultation.TimeEnd)
                  }
                ).then((calculateResponse) => {
                  if (res.Consultation.StatusCode == 'PA') { commit('CALL_END_BY', 'connection') } else if (res.Consultation.StatusCode == 'PE') { commit('CALL_END_BY', 'patient') } else if (res.Consultation.StatusCode == 'TO') { commit('CALL_END_BY', 'timer') } else { commit('CALL_END_BY', 'doctor') }

                  commit('SET_CALL_STATUS', 'CALL_ENDED')
                  commit('SET_IN_CONSULTATION', false)
                  commit('SET_POSITION', 4)
                  dispatch('getPatientInfoByConsultationID').then(()=>{
                    // call modal modalIsPatientNeedSummary
                    if (res.Consultation.Status == null) {
                      if (res.Consultation.StatusCode && res.Consultation.StatusCode !== 'DE' && res.Consultation.StatusCode !== 'TO') {
                        if(state.consultFrom) {
                          if(state.consultFrom.IsAllowedConsultationICD10) {
                            $nuxt.$bvModal.show('modalIsPatientNeedSummary')
                          }
                        } else {
                          $nuxt.$bvModal.show('modalIsPatientNeedSummary')
                        }
                      }
                    }
                  })
                })
              })
              resolve(res)
            }
          }
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  checkLoginPatient ({rootState}, appointmentID) {
    return new Promise((resolve, reject) => {
      this.$api.post(`doctor/appointment/${appointmentID}/metadata`, null)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error.response)
        })
    })
  },

  doctorAuthorization: _.debounce(function ({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      if (!state.isDoctorAuthorized) {
        if (state.consultation.status === 'DoctorReconnect') { commit('SET_POSITION', 5) } // doctor reconnect
        else { commit('SET_POSITION', 1) }

        dispatch('setQueue').then((res) => {
          dispatch('log', {
            data: 'Set Queue Success. Authorizing...',
            status: 'INFO',
          })
          dispatch(
            '$nuxtSocket/emit',
            {
              label: state.socketPersistName,
              evt: 'DoctorAuthorization',
              msg: state.doctorSessionID
            }, { root: true }
          ).then((resEmit) => {
            dispatch('log', {
              data: 'Doctor Authorized as ' + state.doctorSessionID,
              status: 'INFO',
            })
            commit('SET_DOCTOR_AUTHORIZED', true)

            // send notif to patient after socket practicing connected
            dispatch('sendPushNotification').then((res) => {
              console.log(res, 'res notif')
            }).catch((err) => {
              throw new Error(err)
            }).finally(() => {
              if (state.consultation.status !== 'DoctorReconnect') { commit('SET_POSITION', 2) }
            })

            resolve(true)
          }).catch((errorEmit) => {
            dispatch('log', {
              data: 'Emit Doctor Authorization Error',
              status: 'ERROR',
            })
            location.reload()
            reject(errorEmit)
          })
        }).catch((errorSetQueue) => {
          dispatch('log', {
            data: 'Set Queue Error',
            status: 'ERROR',
          })
          location.reload()
          reject(errorSetQueue)
        })
      }
    })
  }, 100),

  replyComplaintDoctor ({ rootState }, payload) {
    return new Promise((resolve, reject) => {
      this.$api.post(`doctor/complaint/reply/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },

  getComplaintDoctor ({ rootState }) {
    return new Promise((resolve, reject) => {
      this.$api.get('doctor/practice/complaints')
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },

  initRefund ({ rootState }, consultID) {
    return new Promise((resolve, reject) => {
      this.$api.post(rootState.user.auth.role_endpoint + 'initiate/refund/' + consultID, {
        Status: 'INITIAL_REFUND'
      })
        .then((response) => {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  getDetailComplaintDoctor ({ rootState }, id) {
    return new Promise((resolve, reject) => {
      this.$api.get(`doctor/practice/${id}/complaint`)
        .then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },

  getSuccessStatistic ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_STATISTIC_LOADING', {
        key: 'success',
        value: true
      })

      this.$api.get('doctor/statistic', {})
        .then((response) => {
          const res = response.data.Data
          res.total_consultation_success = res.Appointment + res.OnDemand
          res.total_consultation_canceled = res.DoctorCancel + res.PatientCancel
          const month = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
          res.Month = month[res.RunningMonth * 1 - 1]

          commit('SET_STATISTIC_DATA', {
            key: 'success',
            value: res
          })

          commit('SET_STATISTIC_LOADING', {
            key: 'success',
            value: false
          })
          resolve(res)
        })
        .catch((error) => {
          commit('SET_STATISTIC_LOADING', {
            key: 'success',
            value: false
          })
          reject(error)
        })
    })
  },

  getCanceledStatistic ({ commit, rootState }, data) {
    const date_start = Date.parse($nuxt.$moment().startOf('month').format('YYYY-MM-DD')) / 1000
    const date_end = Date.parse($nuxt.$moment().endOf('month').format('YYYY-MM-DD')) / 1000
    const public_id = rootState.user.auth.userData.PublicID

    commit('SET_STATISTIC_LOADING', {
      key: 'canceled',
      value: true
    })

    return new Promise((resolve, reject) => {
      this.$api.get(`doctor/evaluation/${public_id}?Start=${date_start}&End=${date_end}&Page=10`, {})
        .then(function (response) {
          const res = response.data.Data
          const month = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
          if (res.RunningMonth) {
            res.Month = month[res.RunningMonth * 1 - 1]
          } else {
            res.Month = month[new Date().getMonth()]
          }

          commit('SET_STATISTIC_LOADING', {
            key: 'canceled',
            value: false
          })
          commit('SET_STATISTIC_DATA', {
            key: 'canceled',
            value: res
          })
          resolve(res)
        })
        .catch(function (error) {
          commit('SET_STATISTIC_LOADING', {
            key: 'canceled',
            value: false
          })

          reject(error)
        })
    })
  },

  getAllHistory ({ rootState }, data) {
    return new Promise((resolve, reject) => {
      const { page, perpage, keyword } = data

      this.$api.get(`doctor/activities/?page=${page}&PerPage=${perpage}&q=${keyword}`)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  getHistory ({ rootState }, payload) {
    return new Promise((resolve, reject) => {
      const {
        limit,
        page,
        keyword,
        date_start,
        date_end,
        status
      } = payload

      this.$api.get(`doctor/activities/?page=${page}&PerPage=${limit}&q=${keyword}&from=${date_start}&to=${date_end}&status=${status}`)
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  getPatientInfoByConsultationID ({ commit, dispatch, state, rootState }) {
    return new Promise((resolve, reject) => {
      this.$api.get(rootState.user.auth.role_endpoint + 'consult/patient/' + state.consultation.consultationID)
        .then(function (response) {
          const res = response.data

          commit('SET_PHARMACY_DETAIL', res.Data.PharmacyDetail)

          commit('SET_CONSULT_FROM', res.Data.ConsultFrom)

          commit('SET_CONSULTATION', {
            key: 'patientInfo',
            value: res
          })

          commit('SET_CONSULTATION', {
            key: 'patientPersonalData',
            value: res.Data.Patient
          })

          dispatch(
            'getConsultationType'
          )

          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  updateConsultationStatus ({ commit, dispatch, state, rootState }, status) {
    return new Promise((resolve, reject) => {
      this.$api.post(rootState.user.auth.role_endpoint + 'update/practice/' + state.consultation.consultationID, {
        Status: status
      })
        .then((response) => {
          const res = response.data

          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  log ({ commit, dispatch, state, rootState }, payload) {
    const {data, status = 'INFO', consoleLog = true} = payload
    return new Promise((resolve, reject) => {
      const globalSocketAuthorized = rootState.globalSocket.isAuthorized
      const message = `[${$nuxt.$moment().format('YYYY-MM-DD HH:mm:ss')}]${globalSocketAuthorized ? '' : ' [FROM LS]'} [${status}] ${data}`
      if (globalSocketAuthorized) {
        if(consoleLog) console.log(message)
        dispatch(
          '$nuxtSocket/emit',
          {
            label: rootState.globalSocket.socketPersistName,
            evt: 'DoctorPracticeSessionLogs',
            msg: {
              sessionId: state.doctorSessionID,
              tokenLoginId: rootState.user.auth.token,
              message: message
            }
          }, { root: true }
        ).then((resEmit) => {
          console.log('[CONSULTATION LOG]', data)
          resolve(true)
        }).catch((errorEmit) => {
          console.log('[LOGGIN FAILED]', data)
          reject(errorEmit)
        })
      } else {
        const lsData = JSON.parse(localStorage.getItem('offline_log'))
        const data = lsData ? [...lsData, message] : [message]
        localStorage.setItem('offline_log', JSON.stringify(data))
      }
    })
  },

  initConsultation ({ commit, dispatch, state, rootState }) {
    return new Promise((resolve, reject) => {
      // let willCreateConsult = true
      const self = this

      if (state.consultation.status === 'DoctorReconnect') {
        commit('SET_RECORDED', state.consultation.reconnectData.Practicing.IsRecorded)
        commit('SET_CONSULTATION', {
          key: 'consultationID',
          value: state.consultation.reconnectData.Practicing.ID
        })
        commit('SET_CONSULTATION', {
          key: 'userSymptoms',
          value: state.consultation.reconnectData.Practicing.SymptomNotes
        })
        commit('SET_CONSULTATION', {
          key: 'userSymptomsID',
          value: state.consultation.reconnectData.Practicing.SymptomID
        })
        commit('SET_CONSULTATION', {
          key: 'userSymptomsIcon',
          value: state.consultation.reconnectData.Practicing.SymptomIcon
        })
        commit('SET_CONSULTATION', {
          key: 'pharmacy',
          value: state.consultation.reconnectData.Practicing.pharmacy
        })

        dispatch('$nuxtSocket/emit', {
          label: state.socketPersistName,
          evt: 'ConsultationID',
          msg: state.consultation.reconnectData.Practicing.ID
        }, { root: true }
        )
        dispatch('emitMessage', { id: 'ConsultationID', data: state.consultation.reconnectData.Practicing.ID })
      }

      dispatch('log', {
        data: 'Current Status while Init Consultation: ' + state.consultation.status,
        status: 'INFO',
      })
      dispatch('log', {
        data: 'Consultation ID: ' + state.consultation.consultationID,
        status: 'INFO',
      })

      // check current practice is exist
      self.$api.get(rootState.user.auth.role_endpoint + 'current/practice/' + state.doctorSessionID)
        .then(function (response) {
          const resCheckPractice = response.data

          if (!resCheckPractice || resCheckPractice.status === 204) {
            dispatch('log', {
              data: 'Create Practicing Data...',
              status: 'INFO',
            })

            const formData = {
              DoctorSessionID: state.doctorSessionID,
              PatientSessionID: state.patientSessionID,
              PatientID: state.patientID
            }

            self.$api.post(rootState.user.auth.role_endpoint + 'create/consultation', formData)
              .then(function (response) {
                const res = response.data.Data

                commit('SET_RECORDED', res.IsRecorded)
                commit('SET_CONSULTATION', {
                  key: 'consultationID',
                  value: res.ID
                })

                dispatch('$nuxtSocket/emit', {
                  label: state.socketPersistName,
                  evt: 'ConsultationID',
                  msg: res.ID
                }, { root: true }
                )
                dispatch('getPatientInfoByConsultationID')
                dispatch('startTimer')
                dispatch('getChatHistories')
                resolve(true)
              })
              .catch(function (error) {
                reject(error)
              })
            return
          }

          dispatch('log', {
            data: 'Practicing Data Found',
            status: 'INFO',
          })

          const data = resCheckPractice.Data

          commit('SET_RECORDED', data.IsRecorded)
          commit('SET_CONSULTATION', {
            key: 'consultationID',
            value: data.ID
          })
          commit('SET_CONSULTATION', {
            key: 'userSymptoms',
            value: data.SymptomNotes
          })
          commit('SET_CONSULTATION', {
            key: 'userSymptomsID',
            value: data.Symptoms
          })
          commit('SET_CONSULTATION', {
            key: 'pharmacy',
            value: data.PharmacyID
          })

          dispatch('$nuxtSocket/emit', {
            label: state.socketPersistName,
            evt: 'ConsultationID',
            msg: data.ID
          }, { root: true }
          )
          dispatch('emitMessage', { id: 'ConsultationID', data: data.ID })
          dispatch('getPatientInfoByConsultationID')
          dispatch('startTimer')
          dispatch('getChatHistories')
          resolve(true)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  createPracticingVideo ({ commit, dispatch, state, rootState }, data) {
    return new Promise((resolve, reject) => {
      const { PracticingID, DoctorSessionID, DoctorID } = data

      this.$api.post(rootState.user.auth.role_endpoint + 'save/practicing/video', {
        PracticingID,
        DoctorSessionID,
        DoctorID
      })
        .then((response) => {
          const res = response.data

          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  getConsultationSchedule ({ commit, dispatch, state, rootState }) {
    return new Promise((resolve, reject) => {
      this.$api.get(rootState.user.auth.role_endpoint + 'schedule/practicing/' + state.consultation.consultationID)
        .then((response) => {
          const res = response.data

          if (res.Data) {
            commit('SET_CONSULTATION', {
              key: 'schedule',
              value: res.Data
            })
            resolve(res.Data)
          }
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  getConsultationType ({ commit, state, rootState }) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()

      formData.append('keyword', 'get-consultation-type')
      formData.append('psid', state.patientSessionID)

      this.$api.get(rootState.user.auth.role_endpoint + 'consult/type/' + state.patientSessionID)
        .then(function (response) {
          const res = response.data.Data

          if (res) {
            if (res.IsTesting == '1') {
              commit('SET_CONSULTATION', {
                key: 'consultationType',
                value: 'TESTING'
              })
            } else if (res.BusinessID != null) {
              commit('SET_CONSULTATION', {
                key: 'consultationType',
                value: 'BUSINESS'
              })
            } else if (res.InsuranceID != null) {
              commit('SET_CONSULTATION', {
                key: 'consultationType',
                value: 'INSURANCE'
              })
              // self.loadInsuranceAvatar(patient.InsuranceID);
            } else if (res.IsCampaign == '1') {
              commit('SET_CONSULTATION', {
                key: 'consultationType',
                value: 'SPONSOR'
              })
            } else if (res.UsePoint != null) { // if use yespoint, show package consultation instead
              commit('SET_CONSULTATION', {
                key: 'consultationType',
                value: 'CONSULTATION'
              })
              commit('SET_CONSULTATION', {
                key: 'consultationTypeFlag',
                value: 'PACKAGE'
              })
            } else if (res.SponsorID != null) {
              // self.loadSponsorData(patient.SponsorID);
              commit('SET_CONSULTATION', {
                key: 'consultationType',
                value: 'PAID'
              })
            } else {
              commit('SET_CONSULTATION', {
                key: 'consultationType',
                value: 'PAID'
              })
            }
          }

          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  setScheduleTimer: _.debounce(function ({ commit, dispatch, state }, epochTime) {
    let curr = epochTime

    // get server time
    dispatch('calendar/getServerTime', {}, { root: true }).then((response) => {
      const localTime = Date.now()
      const serverTime = response * 1000

      if (localTime > serverTime) { curr += parseFloat(localTime) - parseFloat(serverTime) } else if (localTime < serverTime) { curr -= parseFloat(serverTime) - parseFloat(localTime) }

      commit('SET_SCHEDULE_TIMER', {
        key: 'deadline',
        value: new Date().getTime() + curr
      })

      function getRemainingTime (deadline) {
        const currentTime = new Date().getTime()
        return deadline - currentTime
      }

      if (curr >= 0) {
        let seconds = Math.floor((curr % (1000 * 60)) / 1000)
        let minutes = Math.floor((curr % (1000 * 60 * 60)) / (1000 * 60))
        let hours = Math.floor((curr % (1000 * 60 * 60 * 60)) / (1000 * 60 * 60))
        let days = Math.floor((curr % (1000 * 60 * 60 * 60 * 24)) / (1000 * 60 * 60 * 24))
        let weeks = Math.floor((curr % (1000 * 60 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24 * 7))

        if (minutes < 10) { minutes = '0' + minutes }
        if (seconds < 10) { seconds = '0' + seconds }

        if (state.scheduleTimer.counterIntervalObject) { clearInterval(state.scheduleTimer.counterIntervalObject) }

        commit('SET_SCHEDULE_TIMER', {
          key: 'epochTimer',
          value: curr
        })

        commit('SET_SCHEDULE_TIMER', {
          key: 'timerSeconds',
          value: seconds
        })

        commit('SET_SCHEDULE_TIMER', {
          key: 'timerMinutes',
          value: minutes
        })

        commit('SET_SCHEDULE_TIMER', {
          key: 'timerHours',
          value: hours
        })

        commit('SET_SCHEDULE_TIMER', {
          key: 'timerDays',
          value: days
        })

        commit('SET_SCHEDULE_TIMER', {
          key: 'timerWeeks',
          value: weeks
        })

        commit('SET_SCHEDULE_TIMER', {
          key: 'counterIntervalObject',
          value: setInterval(() => {
            const remainingTime = getRemainingTime(state.scheduleTimer.deadline)

            seconds = Math.floor((remainingTime % (1000 * 60)) / 1000)
            minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60))
            hours = Math.floor((remainingTime % (1000 * 60 * 60 * 60)) / (1000 * 60 * 60))
            days = Math.floor((remainingTime % (1000 * 60 * 60 * 60 * 24)) / (1000 * 60 * 60 * 24))
            weeks = Math.floor((remainingTime % (1000 * 60 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24 * 7))

            if (minutes < 10) { minutes = '0' + minutes }
            if (seconds < 10) { seconds = '0' + seconds }

            commit('SET_SCHEDULE_TIMER', {
              key: 'epochTimer',
              value: remainingTime
            })

            commit('SET_SCHEDULE_TIMER', {
              key: 'timerSeconds',
              value: seconds
            })

            commit('SET_SCHEDULE_TIMER', {
              key: 'timerMinutes',
              value: minutes
            })

            commit('SET_SCHEDULE_TIMER', {
              key: 'timerHours',
              value: hours
            })

            commit('SET_SCHEDULE_TIMER', {
              key: 'timerDays',
              value: days
            })

            commit('SET_SCHEDULE_TIMER', {
              key: 'timerWeeks',
              value: weeks
            })

            if (curr < 0) {
              dispatch('clearScheduleTimer')
            }
          }, 1000)
        })
      }
    })
  }, 100),

  clearScheduleTimer ({ commit, dispatch, state }) {
    commit('SET_SCHEDULE_TIMER', {
      key: 'epochTimer',
      value: null
    })

    commit('SET_SCHEDULE_TIMER', {
      key: 'deadline',
      value: null
    })

    commit('SET_SCHEDULE_TIMER', {
      key: 'timerSeconds',
      value: ''
    })

    commit('SET_SCHEDULE_TIMER', {
      key: 'timerMinutes',
      value: ''
    })

    commit('SET_SCHEDULE_TIMER', {
      key: 'timerHours',
      value: ''
    })

    commit('SET_SCHEDULE_TIMER', {
      key: 'timerDays',
      value: ''
    })

    commit('SET_SCHEDULE_TIMER', {
      key: 'timerWeeks',
      value: ''
    })

    clearInterval(state.scheduleTimer.counterIntervalObject)

    commit('SET_SCHEDULE_TIMER', {
      key: 'counterIntervalObject',
      value: null
    })
  },

  setExpiredConsultationTimer ({ commit, dispatch, state }, epochTime) {
    let curr = epochTime

    // get server time
    dispatch('calendar/getServerTime', {}, { root: true }).then((response) => {
      const localTime = Date.now()
      const serverTime = response * 1000

      if (localTime > serverTime) { curr += parseFloat(localTime) - parseFloat(serverTime) } else if (localTime < serverTime) { curr -= parseFloat(serverTime) - parseFloat(localTime) }

      if (curr >= 0) {
        let seconds = Math.floor((curr % (1000 * 60)) / 1000)
        let minutes = Math.floor((curr % (1000 * 60 * 60)) / (1000 * 60))
        let hours = Math.floor((curr % (1000 * 60 * 60 * 60)) / (1000 * 60 * 60))
        let days = Math.floor((curr % (1000 * 60 * 60 * 60 * 24)) / (1000 * 60 * 60 * 24))
        let weeks = Math.floor((curr % (1000 * 60 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24 * 7))

        if (minutes < 10) { minutes = '0' + minutes }
        if (seconds < 10) { seconds = '0' + seconds }

        if (state.expiredConsultationTimer.counterIntervalObject) { clearInterval(state.expiredConsultationTimer.counterIntervalObject) }

        commit('SET_EXPIRED_CONSULTATION_TIMER', {
          key: 'epochTimer',
          value: curr
        })

        commit('SET_EXPIRED_CONSULTATION_TIMER', {
          key: 'timerSeconds',
          value: seconds
        })

        commit('SET_EXPIRED_CONSULTATION_TIMER', {
          key: 'timerMinutes',
          value: minutes
        })

        commit('SET_EXPIRED_CONSULTATION_TIMER', {
          key: 'counterIntervalObject',
          value: setInterval(() => {
            curr -= 1000

            seconds = Math.floor((curr % (1000 * 60)) / 1000)
            minutes = Math.floor((curr % (1000 * 60 * 60)) / (1000 * 60))
            hours = Math.floor((curr % (1000 * 60 * 60 * 60)) / (1000 * 60 * 60))
            days = Math.floor((curr % (1000 * 60 * 60 * 60 * 24)) / (1000 * 60 * 60 * 24))
            weeks = Math.floor((curr % (1000 * 60 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24 * 7))

            if (minutes < 10) { minutes = '0' + minutes }
            if (seconds < 10) { seconds = '0' + seconds }

            commit('SET_EXPIRED_CONSULTATION_TIMER', {
              key: 'epochTimer',
              value: curr
            })

            commit('SET_EXPIRED_CONSULTATION_TIMER', {
              key: 'timerSeconds',
              value: seconds
            })

            commit('SET_EXPIRED_CONSULTATION_TIMER', {
              key: 'timerMinutes',
              value: minutes
            })

            // if (curr < 0)
            //   dispatch('clearExpiredConsultationTimer')
          }, 1000)
        })
      }
    })
  },

  clearExpiredConsultationTimer ({ commit, dispatch, state }) {
    commit('SET_EXPIRED_CONSULTATION_TIMER', {
      key: 'epochTimer',
      value: null
    })

    commit('SET_EXPIRED_CONSULTATION_TIMER', {
      key: 'timerSeconds',
      value: ''
    })

    commit('SET_EXPIRED_CONSULTATION_TIMER', {
      key: 'timerMinutes',
      value: ''
    })

    clearInterval(state.expiredConsultationTimer.counterIntervalObject)

    commit('SET_EXPIRED_CONSULTATION_TIMER', {
      key: 'counterIntervalObject',
      value: null
    })
  },

  setCallingPatientTimer ({ commit, dispatch, state }, epochTime) {
    let curr = epochTime

    if (curr >= 0) {
      let seconds = Math.floor((curr % (1000 * 60)) / 1000)
      let minutes = Math.floor((curr % (1000 * 60 * 60)) / (1000 * 60))
      let hours = Math.floor((curr % (1000 * 60 * 60 * 60)) / (1000 * 60 * 60))
      let days = Math.floor((curr % (1000 * 60 * 60 * 60 * 24)) / (1000 * 60 * 60 * 24))
      let weeks = Math.floor((curr % (1000 * 60 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24 * 7))

      if (minutes < 10) { minutes = '0' + minutes }
      if (seconds < 10) { seconds = '0' + seconds }

      if (state.callingPatientTimer.counterIntervalObject) { clearInterval(state.callingPatientTimer.counterIntervalObject) }

      commit('SET_CALLING_PATIENT_TIMER', {
        key: 'epochTimer',
        value: curr
      })

      commit('SET_CALLING_PATIENT_TIMER', {
        key: 'timerSeconds',
        value: seconds
      })

      commit('SET_CALLING_PATIENT_TIMER', {
        key: 'timerMinutes',
        value: minutes
      })

      commit('SET_CALLING_PATIENT_TIMER', {
        key: 'counterIntervalObject',
        value: setInterval(() => {
          curr -= 1000

          seconds = Math.floor((curr % (1000 * 60)) / 1000)
          minutes = Math.floor((curr % (1000 * 60 * 60)) / (1000 * 60))
          hours = Math.floor((curr % (1000 * 60 * 60 * 60)) / (1000 * 60 * 60))
          days = Math.floor((curr % (1000 * 60 * 60 * 60 * 24)) / (1000 * 60 * 60 * 24))
          weeks = Math.floor((curr % (1000 * 60 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24 * 7))

          if (minutes < 10) { minutes = '0' + minutes }
          if (seconds < 10) { seconds = '0' + seconds }

          commit('SET_CALLING_PATIENT_TIMER', {
            key: 'epochTimer',
            value: curr
          })

          commit('SET_CALLING_PATIENT_TIMER', {
            key: 'timerSeconds',
            value: seconds
          })

          commit('SET_CALLING_PATIENT_TIMER', {
            key: 'timerMinutes',
            value: minutes
          })

          if (curr < 0) { dispatch('clearCallingPatientTimer') }
        }, 1000)
      })
    }
  },

  clearCallingPatientTimer ({ commit, dispatch, state }) {
    commit('SET_CALLING_PATIENT_TIMER', {
      key: 'epochTimer',
      value: null
    })

    commit('SET_CALLING_PATIENT_TIMER', {
      key: 'timerSeconds',
      value: ''
    })

    commit('SET_CALLING_PATIENT_TIMER', {
      key: 'timerMinutes',
      value: ''
    })

    clearInterval(state.callingPatientTimer.counterIntervalObject)

    commit('SET_CALLING_PATIENT_TIMER', {
      key: 'counterIntervalObject',
      value: null
    })
  },

  calculateSummaryTimer ({ commit, dispatch, state, rootState }, { startConsultTime, endConsultTime }) {
    return new Promise((resolve, reject) => {
      if (endConsultTime == null || !endConsultTime || typeof endConsultTime === 'undefined') {
        // get server time
        dispatch('calendar/getServerTime', {}, { root: true }).then((response) => {
          const localTime = Date.now()
          const serverTime = response * 1000

          // find differences
          const diff = parseFloat(localTime) - parseFloat(serverTime)

          dispatch('setSummaryTimer', ((startConsultTime - (localTime / 1000)) + (diff / 1000)) * 1000)
          resolve(true)
        })
      } else {
        dispatch('setSummaryTimer', (startConsultTime - endConsultTime) * 1000)
        resolve(true)
      }
    })

    // just for testing
    // dispatch('setSummaryTimer', 30 * 1000)
  },

  setSummaryTimer ({ commit, dispatch, state }, epochTime) {
    let curr = epochTime
    commit('SET_SUMMARY_TIMER', {
      key: 'deadline',
      value: new Date().getTime() + curr
    })

    function getRemainingTime (deadline) {
      const currentTime = new Date().getTime()
      return deadline - currentTime
    }

    if (curr >= 0) {
      let seconds = Math.floor((curr % (1000 * 60)) / 1000)
      let minutes = Math.floor((curr % (1000 * 60 * 60)) / (1000 * 60))
      let hours = Math.floor((curr % (1000 * 60 * 60 * 60)) / (1000 * 60 * 60))
      let days = Math.floor((curr % (1000 * 60 * 60 * 60 * 24)) / (1000 * 60 * 60 * 24))
      let weeks = Math.floor((curr % (1000 * 60 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24 * 7))

      if (minutes < 10) { minutes = '0' + minutes }
      if (seconds < 10) { seconds = '0' + seconds }

      if (state.summaryTimer.counterIntervalObject) { clearInterval(state.summaryTimer.counterIntervalObject) }

      commit('SET_SUMMARY_TIMER', {
        key: 'epochTimer',
        value: curr
      })

      commit('SET_SUMMARY_TIMER', {
        key: 'timerSeconds',
        value: seconds
      })

      commit('SET_SUMMARY_TIMER', {
        key: 'timerMinutes',
        value: minutes
      })

      commit('SET_SUMMARY_TIMER', {
        key: 'timerHours',
        value: hours
      })

      commit('SET_SUMMARY_TIMER', {
        key: 'timerDays',
        value: days
      })

      commit('SET_SUMMARY_TIMER', {
        key: 'timerWeeks',
        value: weeks
      })

      commit('SET_SUMMARY_TIMER', {
        key: 'counterIntervalObject',
        value: setInterval(() => {
          const remainingTime = getRemainingTime(state.summaryTimer.deadline)

          seconds = Math.floor((remainingTime % (1000 * 60)) / 1000)
          minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60))
          hours = Math.floor((remainingTime % (1000 * 60 * 60 * 60)) / (1000 * 60 * 60))
          days = Math.floor((remainingTime % (1000 * 60 * 60 * 60 * 24)) / (1000 * 60 * 60 * 24))
          weeks = Math.floor((remainingTime % (1000 * 60 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24 * 7))

          if (minutes < 10) { minutes = '0' + minutes }
          if (seconds < 10) { seconds = '0' + seconds }

          commit('SET_SUMMARY_TIMER', {
            key: 'epochTimer',
            value: remainingTime
          })

          commit('SET_SUMMARY_TIMER', {
            key: 'timerSeconds',
            value: seconds
          })

          commit('SET_SUMMARY_TIMER', {
            key: 'timerMinutes',
            value: minutes
          })

          commit('SET_SUMMARY_TIMER', {
            key: 'timerHours',
            value: hours
          })

          commit('SET_SUMMARY_TIMER', {
            key: 'timerDays',
            value: days
          })

          commit('SET_SUMMARY_TIMER', {
            key: 'timerWeeks',
            value: weeks
          })
        }, 1000)
      })
    }
  },

  clearSummaryTimer ({ commit, dispatch, state, rootState }) {
    commit('SET_SUMMARY_TIMER', {
      key: 'epochTimer',
      value: null
    })

    commit('SET_SUMMARY_TIMER', {
      key: 'deadline',
      value: null
    })

    commit('SET_SUMMARY_TIMER', {
      key: 'timerSeconds',
      value: ''
    })

    commit('SET_SUMMARY_TIMER', {
      key: 'timerMinutes',
      value: ''
    })

    commit('SET_SUMMARY_TIMER', {
      key: 'timerHours',
      value: ''
    })

    commit('SET_SUMMARY_TIMER', {
      key: 'timerDays',
      value: ''
    })

    commit('SET_SUMMARY_TIMER', {
      key: 'timerWeeks',
      value: ''
    })

    clearInterval(state.summaryTimer.counterIntervalObject)

    commit('SET_SUMMARY_TIMER', {
      key: 'counterIntervalObject',
      value: null
    })

    if(state.consultFrom) {
      if(state.consultFrom.IsAllowedConsultationICD10) {
        dispatch('checkUnfinishedConsultation', state.consultation.consultationID)
      }
      // else {
      //   dispatch('submitConsultations', {
      //     Weight: rootState.user.auth.userData ? rootState.user.auth.userData.Weight || 0 : 0,
      //     Height: rootState.user.auth.userData ? rootState.user.auth.userData.Height || 0 : 0,
      //     BloodType: rootState.user.auth.userData ? rootState.user.auth.userData.BloodType || '-' : '-',
      //     MaritalStatus: rootState.user.auth.userData ? rootState.user.auth.userData.MaritalStatus || '-' : '-',
      //     MedicineRecommendations:[],
      //     RoutineMedicine:[],
      //   })
      // }
    } else {
      dispatch('checkUnfinishedConsultation', state.consultation.consultationID)
    }

    // if summary timer ends, but there is next schedule
    // if (state.scheduleTimer.epochTimer <= (5 * 60 * 1000))
    commit('RESET', 'KEEP_PATIENT_INFO_DATA')
  },

  startTimer ({ commit, dispatch, state }) {
    dispatch(
      '$nuxtSocket/emit',
      {
        label: state.socketPersistName,
        evt: 'TimeRemaining',
        msg: 1
      }, { root: true }
    ).then((resEmit) => {
      if (typeof resEmit.TimeRemaining === 'number' && resEmit.TimeRemaining > 0) {
        commit('SET_CONSULTATION', {
          key: 'consultationTimer',
          value: resEmit.TimeRemaining
        })

        commit('SET_CONSULTATION', {
          key: 'consultationTimerDeadline',
          value: (new Date().getTime() / 1000) + resEmit.TimeRemaining
        })

        commit('SET_TIME_REMAINING_ATTEMPT', 5)
      } else {
        if (state.timeRemainingAttempt > 0) {
          setTimeout(() => {
            commit('SET_TIME_REMAINING_ATTEMPT', state.timeRemainingAttempt - 1)
            dispatch('startTimer')
          }, 500)
        }
      }

      function getRemainingTime (deadline) {
        const currentTime = new Date().getTime() / 1000
        return parseInt(deadline - currentTime)
      }

      if (state.consultation.consultationTimerObject) { clearInterval(state.consultation.consultationTimerObject) }

      commit('SET_CONSULTATION', {
        key: 'consultationTimerObject',
        value: setInterval(() => {
          commit('SET_CONSULTATION', {
            key: 'consultationTimer',
            value: getRemainingTime(state.consultation.consultationTimerDeadline)
          })
        }, 1000)
      })

      dispatch('log', {
        data: 'Consultation Timer Started: ' + JSON.stringify(resEmit),
        status: 'INFO',
      })
    }).catch((errorEmit) => {
      dispatch('log', {
        data: 'Emit Time Remaining Failed',
        status: 'ERROR',
      })
    })
  },

  endTimer ({ commit, dispatch, state }) {
    commit('SET_CONSULTATION', {
      key: 'lastConsultationTimer',
      value: state.consultation.consultationTimer
    })

    commit('SET_CONSULTATION', {
      key: 'consultationTimer',
      value: null
    })

    commit('SET_CONSULTATION', {
      key: 'consultationTimerDeadline',
      value: null
    })

    commit('SET_CONSULTATION', {
      key: 'consultationTimerObject',
      value: clearInterval(state.consultation.consultationTimerObject)
    })
  },

  endCall ({ commit, dispatch, state, rootState }) {
    return new Promise((resolve, reject) => {
      dispatch(
        '$nuxtSocket/emit',
        {
          label: state.socketPersistName,
          evt: 'EndCall',
          msg: 1
        }, { root: true }
      )

      dispatch('endTimer')
      dispatch('calculateSummaryTimer',
        {
          startConsultTime: rootState.calendar.currentSchedule.End
        }
      ).then((response) => {
        commit('CALL_END_BY', 'doctor')
        commit('SET_CALL_STATUS', 'CALL_ENDED')
        commit('SET_IN_CONSULTATION', false)
        commit('SET_POSITION', 4)

        resolve(true)
      })
    })
  },

  onPatientEndCall ({ commit, dispatch, state, rootState }) {
    return new Promise((resolve, reject) => {
      dispatch('endTimer')
      dispatch('calculateSummaryTimer',
        {
          startConsultTime: rootState.calendar.currentSchedule.End
        }
      ).then((response) => {
        commit('CALL_END_BY', 'patient')
        commit('SET_CALL_STATUS', 'CALL_ENDED')
        commit('SET_IN_CONSULTATION', false)
        commit('SET_POSITION', 4)
        resolve(true)
      })
    })
  },

  timerOut ({ commit, dispatch, state, rootState }) {
    dispatch('endTimer')
    dispatch('calculateSummaryTimer',
      {
        startConsultTime: rootState.calendar.currentSchedule.End
      }
    ).then((response) => {
      commit('CALL_END_BY', 'timer')
      commit('SET_CALL_STATUS', 'CALL_ENDED')
      commit('SET_IN_CONSULTATION', false)
      commit('SET_POSITION', 4)
    })
  },

  onConnect ({ commit, dispatch, state }) {
    dispatch('log', {
      data: 'Consultation Connected to Socket ',
      status: 'INFO',
    })

    commit('CONNECT')
  },

  onDisconnect ({ commit, dispatch, state }) {
    dispatch('log', {
      data: 'Consultation Disconnected from Socket ',
      status: 'INFO',
    })
  },

  onPatientDisconnect ({ commit, dispatch, state }) {
    commit('SET_CONSULTATION', {
      key: 'status',
      value: 'PatientDisconnect'
    })

    // if patient disconnected while calling
    if (state.isCalling) {
      commit('SET_CONSULTATION', {
        key: 'status',
        value: 'PatientDisconnectOnDoctorCalling'
      })

      commit('SET_CALLING', false)
    }

    dispatch('log', {
      data: 'Patient Disconnected',
      status: 'INFO',
    })
  },

  emitCall ({ commit, dispatch, state }, data) {
    const { sdp } = data

    dispatch(
      '$nuxtSocket/emit',
      {
        label: state.socketPersistName,
        evt: 'Call',
        msg: { id: 'Call', sdpOffer: sdp }
      }, { root: true }
    ).then((resEmit) => {
      commit('SET_LOCAL_SDP', sdp)
      dispatch('log', {
        data: 'Emit Call: ' + JSON.stringify(resEmit),
        status: 'INFO',
      })
    }).catch((errorEmit) => {
      dispatch('log', {
        data: 'Emit Call Failed',
        status: 'ERROR',
      })
    })
  },

  emitChat ({ commit, dispatch, state }, data) {
    return new Promise((resolve, reject) => {
      dispatch(
        '$nuxtSocket/emit',
        {
          label: state.socketPersistName,
          evt: 'Chat',
          msg: data
        }, { root: true }
      ).then((resEmit) => {
        dispatch('log', {
          data: 'Emit Chat: ' + JSON.stringify(resEmit),
          status: 'INFO',
        })
        resolve(resEmit)
      }).catch((errorEmit) => {
        dispatch('log', {
          data: 'Emit Chat Failed',
          status: 'ERROR',
        })
        reject(errorEmit)
      })
    })
  },

  emitMessage ({ commit, dispatch, state }, data) {
    dispatch(
      '$nuxtSocket/emit',
      {
        label: state.socketPersistName,
        evt: 'Message',
        msg: data
      }, { root: true }
    ).then((resEmit) => {
      dispatch('log', {
        data: 'Emit Message: ' + JSON.stringify(data),
        status: 'INFO',
      })
    }).catch((errorEmit) => {
      dispatch('log', {
        data: 'Emit Message Failed',
        status: 'ERROR',
      })
    })
  },

  emitMissedCall ({ commit, dispatch, state }) {
    dispatch(
      '$nuxtSocket/emit',
      {
        label: state.socketPersistName,
        evt: 'MissedCall',
        msg: 1
      }, { root: true }
    )

    $nuxt.$emit('patientNoAnswer')

    dispatch('log', {
      data: 'Patient Missed The Call',
      status: 'INFO',
    })
  },

  getMedicineInfo ({ commit, dispatch, state, rootState }, text) {
    return new Promise((resolve, reject) => {
      const req = {
        method: 'post',
        url: process.env.BASE_IO_URL + `ajax/drugs.php?q=${text}`,
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        }
      }
      this.$axios(req)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  submitConsultations ({ commit, dispatch, state, rootState }, data) {
    return new Promise((resolve, reject) => {
      const id = state.consultation.consultationID
      const formData = new FormData()
      const stringMedRec = data ? JSON.stringify(data.MedicineRecommendations) : null
      const stringRoutineMed = data ? JSON.stringify(data.RoutineMedicine) : null

      formData.append('MedicineVersion', '4.0')

      if(data) {
        if(data.Weight >= 0) {
          formData.append('Weight', data.Weight)
        }

        if(data.Height >= 0) {
          formData.append('Height', data.Height)
        }

        if (data.HealingEstimation) {
          formData.append('HealingEstimation', data.HealingEstimation)
        }

        if (data.Notes) {
          formData.append('Notes', data.Notes)
        }

        if (data.BloodType) {
          formData.append('BloodType', data.BloodType)
        } else {
          formData.append('BloodType', '-')
        }
        if (data.MaritalStatus) {
          formData.append('MaritalStatus', data.MaritalStatus)
        }
        if(data.MedicineRecommendations) {
          if (data.MedicineRecommendations.length === 1) {
            if (data.MedicineRecommendations[0].GenericMedicineName) {
              formData.append('MedicineRecommendations', stringMedRec)
            } else {
              formData.append('MedicineRecommendations', '[]')
            }
          } else if (data.MedicineRecommendations.length === 0) {
            formData.append('MedicineRecommendations', '[]')
          } else {
            formData.append('MedicineRecommendations', stringMedRec)
          }
        }
        if(data.RoutineMedicine) {
          if (data.RoutineMedicine.length !== 0) {
            formData.append('RoutineMedicine', stringRoutineMed)
          } else {
            formData.append('RoutineMedicine', '[]')
          }
        }
        if (data.Prescription) {
          formData.append('prescription', data.Prescription)
        }
        if (data.Alergi) {
          formData.append('Alergi', data.Alergi)
        }

        if (data.Pradiagnosa) {
          const diagnosa = JSON.stringify(data.Pradiagnosa)
          formData.append('Pradiagnosa', diagnosa)
        }
      }

      const req = {
        method: 'post',
        url: process.env.BASE_API + `doctor/submit/consultation/${id}`,
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        },
        data: formData
      }
      this.$axios(req)
        .then((response) => {
          dispatch('log', {
            data: 'Consultation Submitted: ' + JSON.stringify(response),
            status: 'INFO',
          })
          resolve(response)
        })
        .catch((error) => {
          dispatch('log', {
            data: 'Consultation Failed to submit: ' + error,
            status: 'ERROR',
          })
          reject(error)
        })
    })
  },
  submitNoteConsultations ({ commit, dispatch, state, rootState }, data) {
    return new Promise((resolve, reject) => {
      const id = state.consultation.consultationID
      const formData = new FormData()

      formData.append('MedicineVersion', '4.0')
      formData.append('ProblemNotes', data.Notes)
      const req = {
        method: 'post',
        url: process.env.BASE_API + `doctor/save/incomplete/consultation/${id}`,
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        },
        data: formData
      }
      this.$axios(req)
        .then((response) => {
          dispatch('log', {
            data: 'Consultation Note Submitted: ' + JSON.stringify(response),
            status: 'INFO',
          })
          resolve(response)
        })
        .catch((error) => {
          dispatch('log', {
            data: 'Consultation Note Failed to submit: ' + error,
            status: 'ERROR',
          })
          reject(error)
        })
    })
  },

  getDataICD10 ({ commit, dispatch, state, rootState }, text) {
    return new Promise((resolve, reject) => {
      const req = {
        method: 'get',
        url: process.env.BASE_API + 'doctor/icd/ten',
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + rootState.user.auth.token
        },
        params: {
          q: text
        }
      }
      if (text.length >= 3) {
        this.$axios(req)
          .then((response) => {
            commit('SET_ICD_10', response.data.Data)
            resolve(response.data.Data)
          })
          .catch((error) => {
            reject(error)
          })
      } else {
        commit('SET_ICD_10', [])
      }
    })
  },

  async getTag ({ commit, dispatch, state, rootState }, payload) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()

      formData.append('Keyword', payload.Keyword)
      formData.append('Alias', payload.Alias)

      const req = {
        method: 'post',
        url: process.env.BASE_API_V4 + 'public/medicine/search/generic',
        headers: {
          DeviceType: 'web'
        },
        data: formData
      }
      if (payload.Keyword.length >= 3) {
        this.$axios(req)
          .then((response) => {
            commit('SET_GENERIC', response.data.Data)
            resolve(response.data.Data)
          })
          .catch((error) => {
            reject(error)
          })
      } else {
        commit('SET_GENERIC', [])
      }
    })
  },

  getCategory ({ commit, dispatch, state, rootState }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()

      formData.append('Generic', data.text)

      const req = {
        method: 'post',
        url: process.env.BASE_API_V4 + 'public/medicine/search/category',
        headers: {
          DeviceType: 'web'
        },
        data: formData
      }
      this.$axios(req)
        .then((response) => {
          resolve(response.data.Data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getLabelByCatTag ({ commit, dispatch, state, rootState }, data) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()

      formData.append('Generic', data.genericName)
      // if (data.categoryName) {
      //   formData.append('Category', data.categoryName)
      // }
      if (data.item) {
        formData.append('Category', data.item)
      }

      const req = {
        method: 'post',
        url: process.env.BASE_API_V4 + 'public/medicine/search/product',
        headers: {
          DeviceType: 'web'
        },
        data: formData
      }
      this.$axios(req)
        .then((response) => {
          resolve(response.data.Data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getTagByCat ({ commit, dispatch, state, rootState }, sendData) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()

      formData.append('Generic', sendData.genericName)
      if (sendData.text) {
        formData.append('Category', sendData.text)
        commit('SET_TAG_CATEGORY_TEXT', sendData.text)
      }

      const req = {
        method: 'post',
        url: process.env.BASE_API_V4 + 'public/medicine/search/product',
        headers: {
          DeviceType: 'web'
        },
        data: formData
      }
      this.$axios(req)
        .then((response) => {
          resolve(response.data.Data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  onCall ({ commit, dispatch, state }, response) {
    dispatch('log', {
      data: 'On Call while position is "' + state.position + '" and status is "' + state.consultation.status + '"',
      status: 'INFO',
    })

    // reset ice candidate
    // commit('RTC/RESET_CANDIDATE', {}, { root: true })

    // To keep in the track
    setTimeout(() => {
      dispatch('clearMissedCallTimeout')

      commit('SET_PATIENT_ID', response.PatientID)
      commit('SET_PATIENT_SESSION_ID', response.PatientSessionID)
      commit('SET_CALLING', true)
      commit('SET_POSITION', 3)

      commit('SET_CONSULTATION', {
        key: 'consultationMode',
        value: response.Type
      })

      if (response.Type == 'Video') {
        commit('SET_CONSULTATION', {
          key: 'videoEnabled',
          value: true
        })
      }
      if (response.Type == 'Audio') {
        commit('SET_CONSULTATION', {
          key: 'videoEnabled',
          value: false
        })
      }

      if (!state.consultation.reconnectData || state.consultation.reconnectData == null) { dispatch('setMissedCallTimeout') }
    }, 500)
  },

  setMissedCallTimeout ({ commit, dispatch, state }) {
    dispatch('log', {
      data: 'Missed Call Timer is Running on Background...',
      status: 'INFO',
    })

    commit('SET_MISSED_CALL_TIMEOUT_TIME',
      state.expiredConsultationTimer.epochTimer
        ? Math.min(Math.max(state.expiredConsultationTimer.epochTimer, 60 * 1000), state.missedCallTimeoutTime)
        : state.missedCallTimeoutTime
    )
    commit('SET_MISSED_CALL_TIMEOUT',
      setTimeout(() => {
        dispatch('emitMissedCall')
      }, state.missedCallTimeoutTime)
    )

    dispatch('setCallingPatientTimer', state.missedCallTimeoutTime)
  },

  clearMissedCallTimeout ({ commit, dispatch, state }) {
    dispatch('log', {
      data: 'Reset Missed Call Timer',
      status: 'INFO',
    })
    clearInterval(state.missedCallTimeout)
    clearTimeout(state.missedCallTimeout)
    commit('SET_MISSED_CALL_TIMEOUT', null)
  },

  onScheduleEnded ({ commit, dispatch, state }) {
    dispatch('log', {
      data: 'Schedule Ended',
      status: 'INFO',
    })
  },

  async onData ({ commit, dispatch, state, rootState }, response) {
    dispatch('clearMissedCallTimeout')

    dispatch('log', {
      data: 'On Data: ' + JSON.stringify(response),
      status: 'INFO',
    })

    if (response.Status != 'Accepted') {
      $nuxt.$emit('patientRejectCall')
      dispatch('log', {
        data: 'Patient Reject The Call',
        status: 'INFO',
      })
    } else {
      await dispatch('initConsultation').then((response) => {
        rootState.RTC.iceCandidates.forEach((iceCandidate) => {
          dispatch('emitMessage', { id: 'IceCandidate', data: iceCandidate })
        })

        commit('SET_CALLING', false)
        commit('SET_CALL_STATUS', 'IN_CALL')
        commit('SET_IN_CONSULTATION', true)

        commit('SET_CONSULTATION', {
          key: 'status',
          value: 'Connected'
        })
        dispatch('log', {
          data: 'Patient Accept The Call',
          status: 'INFO',
        })
        dispatch('log', {
          data: 'In Consultation',
          status: 'INFO',
        })
      })
    }
  },

  onMessage ({ commit, dispatch, state }, response) {
    dispatch('log', {
      data: 'On Message: ' + JSON.stringify(response.data),
      status: 'INFO',
    })

    if (response.id == 'ProcessedAnswer') { $nuxt.$emit('setPeerSignal', 'sdp', response.data) }

    if (response.id == 'IceCandidate') { $nuxt.$emit('setPeerSignal', 'candidate', response.data) }

    if (response.CallType) {
      dispatch('log', {
        data: 'Consultation Call Type: ' + response.CallType,
        status: 'INFO',
      })

      commit('SET_CONSULTATION', {
        key: 'consultationMode',
        value: response.CallType
      })

      if (response.CallType == 'Video' || response.CallType == 'Chat') {
        commit('SET_CONSULTATION', {
          key: 'videoEnabled',
          value: true
        })
      }
      if (response.CallType == 'Audio') {
        commit('SET_CONSULTATION', {
          key: 'videoEnabled',
          value: false
        })
      }
    }

    if (response.id == 'IsTyping') {
      dispatch('log', {
        data: 'Consultation Chat is Typing...',
        status: 'INFO',
      })
      commit('SET_CONSULTATION', {
        key: 'isTyping',
        value: true
      })

      setTimeout(() => {
        commit('SET_CONSULTATION', {
          key: 'isTyping',
          value: false
        })
        dispatch('log', {
          data: 'Consultation Chat Stop Typing',
          status: 'INFO',
        })
      }, 2000)
    }

    if (response.Status) {
      if(state.consultation.status === 'PatientDisconnect' && response.Status === 'DeviceBackToForeground') {
        commit('SET_CONSULTATION', {
          'key': 'status',
          'value': state.consultation.status,
        })
        dispatch('log', {
          data: 'Consultation Status: ' + state.consultation.status,
          status: 'INFO',
        })
      } else {
        commit('SET_CONSULTATION', {
          'key': 'status',
          'value': response.Status,
        })
        dispatch('log', {
          data: 'Consultation Status: ' + response.Status,
          status: 'INFO',
        })
      }
    }
  },

  onChat ({ commit, dispatch, state }, response) {
    commit('SET_CONSULTATION', {
      key: 'chat',
      value: { sender: 'Patient', text: response.Message, timestamp: $nuxt.$timeStampToDateTime(response.Timestamp), type: 'text' }
    })
  },

  onReceivingFile ({ commit, dispatch, state }, response) {

  },

  onFileReceived ({ commit, dispatch, state }, response) {
    let ATTACHMENT_URL = process.env.ATTACHMENT_URL

    commit('SET_CONSULTATION', {
      key: 'chat',
      value: {
        ...response,
        sender: 'Patient',
        text: 'Loading..',
        timestamp: $nuxt.$timeStampToDateTime(response.Timestamp),
        type: response.FileMimeType,
        Filename: ATTACHMENT_URL + response.Filename,
        progress: 'success'
      }
    })
  },

  getChatHistories ({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      this.$api.get('doctor/chat/histories?SessionID=' + state.doctorSessionID)
        .then(function (response) {
          const res = response.data.Data
          const value = res.map(async (obj, index) => {
            const a = obj.Type.toLowerCase()
            const data = {}
            if (!obj.Attachment) {
              data.index = index
              data.sender = a.charAt(0).toUpperCase() + a.slice(1)
              data.text = obj.Message
              data.timestamp = obj.Timestamp
              data.type = 'text'
              data.status = 'Terkirim'
            } else if (obj.Attachment) {
              await dispatch('getAttachmentData', {data: obj.Attachment.File}).then(async responseAttachment => {
                const url = window.URL.createObjectURL(new Blob([responseAttachment.data]))
                data.index = index
                data.sender = a.charAt(0).toUpperCase() + a.slice(1)
                data.text = obj.Message
                data.timestamp = obj.Timestamp
                data.type = obj.Attachment.FileType
                data.status = 'Terkirim'
                data.Filename = url
              })
            }

            data.is_history = true
            return data
          })

          if (value) {
            commit('SET_CHAT_CONSULTATION', {
              key: 'chat',
              value: []
            })
            Promise.all(value).then((chat) => {
              if (chat) {
                chat.forEach((c) => {
                  commit('ADD_CHAT_CONSULTATION', {
                    key: 'chat',
                    value: c
                  })
                })
              }
            })
          }
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  getDetailPatient ({ commit }, data) {
    const { token, id } = data
    return new Promise((resolve, reject) => {
      this.$axios.get(process.env.BASE_API + 'doctor/consultation/' + id, {
        headers: {
          DeviceType: 'web',
          Authorization: 'Bearer ' + token
        }
      })
        .then(function (response) {
          const res = response.data.Data[0]
          commit('SET_PATIENT_DATA', res)
          resolve(res)
        })
        .catch(function (error) {
          reject(error.response)
        })
    })
  },

  getPatientAppointment ({ rootState }) {
    return new Promise((resolve, reject) => {
      this.$api.get(process.env.BASE_API + 'doctor/next/patient')
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error.response)
        })
    })
  },

  sendPushNotification ({ state, rootState }) {
    return new Promise((resolve, reject) => {
      this.$api.post('doctor/send/push/call/' + state.doctorSessionID, {})
        .then(function (response) {
          const res = response.data
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  sendAttachment ({ state, commit, dispatch }, files) {
    return new Promise((resolve, reject) => {
      let formData = new FormData()
      formData.append('SessionID',state.doctorSessionID)
      formData.append('File',files)

      this.$axios.post(process.env.SOCKET_URL + '/DoctorSendFile', formData)
        .then(function (response) {
          const res = response.data
          dispatch('log', {
            data: 'Attachment Sent: ' + JSON.stringify(res),
            status: 'INFO',
          })
          resolve(res)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  getDoctorAttachment({ state, commit }, filename) {
    return new Promise((resolve, reject) => {
      resolve(process.env.SOCKET_URL + '/attachments/' + filename)
      // this.$axios.get(process.env.SOCKET_URL + '/doctorattachments/' + filename)
      //   .then(function (response) {
      //     const res = response.data
      //     resolve(res)
      //   })
      //   .catch(function (error) {
      //     reject(error)
      //   })
    })
  },

  setPreviewAttachment ({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit('SET_PREVIEW_ATTACHMENT', data)
    })
  },

  setDataAttachment ({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit('SET_DATA_ATTACHMENT', data)
    })
  },

  setPreviewImage ({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit('SET_PREVIEW_IMAGE', data)
    })
  },

  getAttachmentData ({ rootState }, payload) {
    const { data, responseType = 'blob', Accept = '*' } = payload

    return new Promise((resolve, reject) => {
      this.$axios.get(data, {
        headers: {
          Authorization: 'Bearer ' + rootState.user.auth.token,
          WebVersion: '1',
          DeviceType: 'web',
          UserFrom: 'DOCTOR',
          Accept
        },
        responseType
      })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  },

  getPatientHistory ({ commit, rootState, state }, data) {
    return new Promise((resolve, reject) => {
      const { perpage, page } = data
      if (!state.patientID) { return }

      this.$api.get('doctor/practices/patient/' + state.patientID + '?page=' + page + '&perpage=' + perpage)
        .then(function (response) {
          const res = response.data.Data
          commit('SET_HISTORY_PATIENT', res)
          resolve(res)
        }).catch(function (error) {
          reject(error.response)
        })
    })
  },

  sendFlagVideoUploaded ({ rootState }, id) {
    return new Promise((resolve, reject) => {
      this.$api.post('doctor/practices/recording/complete', { ID: id })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}
